export enum Option {
  Size = "Size",
  Color = "Color",
}
